"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBLogo;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * SVBLogo
 * All these properties are properties  of props
 * @param {string} [logoWidth = ''] - Width of the logo (units must be included),
 * @param {string} [logoHeight = '] - Height of the logo (units must be included),
 * @param {string} [logoMargin = '] - Margin of the logo (units must be included),
 * @param {func} [handleOnClick = undefined] - Function to be executed on click,
 * @param {string} imageSource - Name/path of the image,
 * @param {string} [imageAlt = 'logo'] - Alternative text to be shown in case of an error loading the image,
 * @param {string} [extraClasses = ''] - Extra classes to be added to the img element,
 * @returns img JSX element
 */
function SVBLogo(props) {
  const getImage = source => {
    try {
      return require('@svb/svbbranding/dist/assets/icons/' + source);
    } catch (error) {
      return null;
    }
  };
  const width = props.logoWidth || '';
  const height = props.logoHeight || '';
  const margin = props.logoMargin || '';
  const handleOnClick = props.handleOnClick;
  const image = getImage(props.imageSource);
  const imageAlt = props.imageAlt || 'logo';
  const extraClasses = props.extraClasses || '';
  return /*#__PURE__*/_react.default.createElement("img", {
    className: "svb-logo ".concat(extraClasses),
    onClick: handleOnClick,
    src: image,
    alt: imageAlt,
    style: {
      margin,
      height,
      width
    }
  });
}
;
SVBLogo.propTypes = {
  logoWidth: _propTypes.default.string,
  logoHeight: _propTypes.default.string,
  logoMargin: _propTypes.default.string,
  handleOnClick: _propTypes.default.func,
  imageSource: _propTypes.default.string.isRequired,
  imageAlt: _propTypes.default.string,
  extraClasses: _propTypes.default.string
};